// Version : 0.0.2
// Author : AGALYA
// LAST EDIT DONE BY : Shiyam
// LastEdit : added version
// MODFIED DATA : 23-09-2025

import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET OVERDUE REPORT DETAILS START *********************** */
export const overdueReportDetailsGet = (fetchData: any, serviceName: any) => {
	const data = {
		GetoverdueAtRiskReportToken: fetchData,
	};
	const url = `${API_URL + serviceName}`;
	console.log('dvsd', url, data);
	return makeApiCall(url, data);
};
/** ***************** GET OVERDUE REPORT DETAILS END *********************** */

/** ***************** FETCH OVERDUE REPORT EXCEL START *********************** */
export const fetchOverDueExcel = (postData: any, serviceName: any) => {
	const params = new URLSearchParams();
	params.append('FetchOverDueReportToken', postData);
	const url = `${API_URL}Excel/${serviceName}.php`;
	return makeFormApiCall(url, params);
};
/** ***************** FETCH OVERDUE REPORT EXCEL END *********************** */
